import axios from 'axios';

const workerUrl = process.env.REACT_APP_EMAIL_END_POINT
// const https = require('https');
//
// const agent = new https.Agent({     rejectUnauthorized: false, });


const emailInstance = axios.create({
//    baseURL: 'https://spring-glade-bd66.messiasayi.workers.dev/',
    baseURL: workerUrl,

    timeout: 10000,
})

emailInstance
    .interceptors
    .response
    .use((response) => {
        console.log("The response is here my friend ")
        return response
    },
(err) => {
    console.error("une grosse merde ")
    return Promise.reject(err)
})


// send email service
export const emaiService = {
    // contact
    contactUs: async(emailContent) => {
        console.log("Les données du mail ", emailContent)
        return await emailInstance.post('/api/contactUs', {emailContent})
    },
    joinUs: async(emailContent) => {
        console.log("les données du potuleur")
        return await emailInstance.post('/api/joinUs', emailContent)
    }
};